// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"803a1448","402":"18c4643c"}[chunkId] + ".chunk.js";
};